import React from "react";

export const IconContact = ({ handleClick = false }) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={() => (handleClick ? handleClick() : null)}
  >
    <circle cx="24" cy="24" r="24" fill="#4700D1" />
    <path
      d="M30.8442 23.1695C30.8442 24.9246 30.1247 26.5153 28.9618 27.6642C27.7989 28.8148 26.1926 29.5254 24.4172 29.5254C22.6419 29.5254 21.0356 28.8131 19.8727 27.6642C18.7098 26.5136 17.9903 24.9246 17.9903 23.1695M24.362 12.3342C18.4976 12.2965 13.6321 16.9659 13.5027 22.7637C13.4441 25.3749 14.3343 27.7755 15.8526 29.659L15.9303 34.4448C15.9458 35.4413 17.0863 36.0132 17.9075 35.4379L21.0942 33.2051C22.1967 33.5424 23.3751 33.7102 24.5967 33.6777C30.33 33.5219 34.9798 28.8748 35.0816 23.202C35.1886 17.2416 30.3542 12.3719 24.362 12.3342Z"
      stroke="white"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
);

export default IconContact;
